// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/Assets/Donation/backgroungImage.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Container{
    background-color: #000000;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: repeat;
    background-size: 300px 300px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Donation/Container.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,yDAA4E;IAC5E,yBAAyB;IACzB,4BAA4B;AAChC","sourcesContent":[".Container{\n    background-color: #000000;\n    background-image: url('../../../public/Assets/Donation/backgroungImage.png');\n    background-repeat: repeat;\n    background-size: 300px 300px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
